import { alpha, Theme } from '@mui/material';
export default {
    section: {
        '&:not(.section--collapsed) + &': {
            pt: 1.5,
        },
    },
    sectionTitle: {
        fontWeight: 600,
        color: 'primary.main',
        borderBottom: (theme: Theme) => `1px solid ${alpha(theme.palette.primary.main, 1)}`,
        display: 'flex',
        justifyContent: 'space-between',
        '&:hover': {
            cursor: 'pointer',
            opacity: 0.85,
        },
    },
    sectionTitleIcon: {
        flexShrink: 0,
        ml: 1,
        fontSize: '16px',
        display: 'inline-flex',
    },
    sectionControlsContainer: {
        '.section--collapsed &': {
            display: 'none',
        },
    },
    propertyContainer: {},
    propertyTitle: {
        pb: 0.5,
    },
    propertyControlHolder: {},
};
